var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    {
      staticClass: "pa-0",
      staticStyle: { "flex-direction": "column", height: "100%" },
    },
    [
      _c(
        "v-flex",
        [
          _c("TableComponent", {
            ref: "viewer",
            attrs: {
              rowHeaders: _vm.rowHeaders,
              columnHeaders: _vm.columnHeaders,
              data: _vm.data,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        {
          ref: "footer",
          staticStyle: {
            "flex-grow": "0",
            "flex-shrink": "0",
            "background-color": "#f5f5f5",
          },
        },
        [
          _c(
            "v-item-group",
            {
              attrs: { mandatory: "", "active-class": "white--text" },
              model: {
                value: _vm.index,
                callback: function ($$v) {
                  _vm.index = $$v
                },
                expression: "index",
              },
            },
            _vm._l(_vm.spreadsheetHeaders, function (spreadsheetHeader, index) {
              return _c("v-item", {
                key: `spreadsheetHeader-${index}`,
                staticClass: "ma-0",
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ active, toggle }) {
                        return _c(
                          "v-chip",
                          {
                            staticClass: "spreadsheetItem divider-right",
                            attrs: {
                              color: active ? "primary" : "default",
                              selected: active,
                              label: "",
                              small: "",
                            },
                            on: { click: toggle },
                          },
                          [_vm._v(_vm._s(spreadsheetHeader.name))]
                        )
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }